// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ebQz","img":"styles_img__3XSWA","link":"styles_link__2t42j"};